import React from 'react';

import { useFormik } from 'formik';
import {
  // Link,
  useHistory,
  useLocation,
} from 'react-router-dom';

import { FormInput, Button } from 'modules/common/input';

import { usePasswordExpired } from '../hooks';
import { passwordExpiredSchema } from '../validation';

const INIT_FORM = {
  old_password: '',
  password: '',
  password_confirmation: '',
};

function PasswordExpiredForm() {
  const history = useHistory();
  const [isPatchLoading, patch] = usePasswordExpired();
  const [validation, setValidation] = React.useState(false);
  const location = useLocation();

  const { submitForm, setFieldValue, values, errors } = useFormik({
    initialValues: INIT_FORM,
    validationSchema: passwordExpiredSchema,
    validateOnChange: validation,
    validateOnBlur: validation,
    onSubmit: (payload) => {
      patch({ payload, token: location?.token }, () => {
        if (!location?.goBack) {
          history.push('/login');
          return;
        }

        history.push(location?.goBack);
      });
    },
  });

  React.useEffect(() => {
    if (location?.isAllowed) return;

    history.push('/login');
  }, [history, location?.isAllowed]);

  if (!location?.isAllowed) return null;

  return (
    <div className="space-y-5">
      <div className="space-y-3">
        <FormInput
          label="Current Password"
          name="old_password"
          // placeholder="Enter your old password"
          value={values?.old_password || ''}
          type="password"
          autoComplete="none"
          onSetFieldValue={setFieldValue}
          withShowPassword
          error={errors?.old_password}
          required
        />

        <div className="py-3">
          <hr />
        </div>

        <FormInput
          label="New Password"
          name="password"
          // placeholder="Enter your new password"
          value={values?.password || ''}
          type="password"
          autoComplete="none"
          onSetFieldValue={setFieldValue}
          withShowPassword
          withStrengthValidation
          error={errors?.password || errors?.password_passed}
          required
        />
        <FormInput
          label="Confirm Password"
          name="password_confirmation"
          // placeholder="Enter your new password"
          value={values?.password_confirmation || ''}
          type="password_confirmation"
          autoComplete="none"
          onSetFieldValue={setFieldValue}
          withShowPassword
          error={errors?.password_confirmation}
          required
        />
        <div className="mt-2 flex">
          <Button
            className="font-medium text-primary-500 text-sm ml-auto"
            label="Forgot Password?"
            to="/forgot-password"
          />
        </div>
      </div>

      <div className="space-y-3 text-center">
        <div>
          <Button
            onClick={() => {
              submitForm();
              setValidation(true);
            }}
            withLoader
            isLoading={isPatchLoading}
            className="btn primary md w-full"
            label="Update Password"
          />
        </div>
        <div>
          <Button
            onClick={() => history.push(location?.goBack)}
            className="text-sm font-medium text-black hover:underline"
            label="Go back"
          />
        </div>
      </div>
    </div>
  );
}
PasswordExpiredForm.defaultProps = {};

PasswordExpiredForm.propTypes = {};

export default PasswordExpiredForm;
